export const SELECT_TRIGGER_TYPE = 'SELECT_TRIGGER_TYPE';

export function selectTriggerType(selectedTriggerType) {
  return {
    type: SELECT_TRIGGER_TYPE,
    selectedTriggerType
  };
}



// WEBPACK FOOTER //
// ./js/actions/trigger.js